/**
 * Phone Country Code Component
 * Handles international phone number input with country selection
 */

'use strict';

var twentyninetimesCustomForm = twentyninetimesCustomForm || {};

twentyninetimesCustomForm.PhoneCountryCode = {
    // List of countries to exclude from dropdown
    excludedCountries: ['af', 'by', 'cu', 'ir', 'iq', 'kp', 'ru', 'sy', 've', 'ye'],

    /**
     * Initialize phone country code plugin and sync dropdown
     * @param {HTMLElement} formular - The form element
     */
    initialize: function(formular) {
        const input = formular.querySelector('.js-iti-phone');
        if (!input) return;

        // Initialize intl-tel-input plugin
        const iti = window.intlTelInput(input, {
            initialCountry: 'auto',
            excludeCountries: this.excludedCountries,
            geoIpLookup: callback => {
                fetch('https://ipapi.co/json')
                    .then(res => res.json())
                    .then(data => callback(data.country_code))
                    .catch(() => callback('us'));
            }
        });

        // Setup country dropdown synchronization
        this.setupCountryDropdownSync(formular, iti);
    },

    /**
     * Setup synchronization between phone input and country dropdown
     * @param {HTMLElement} formular - The form element
     * @param {Object} iti - The intl-tel-input instance
     */
    setupCountryDropdownSync: function(formular, iti) {
        const addressDropdown = formular.querySelector('.js-iti-address-country');
        if (!addressDropdown) return;

        // Populate country dropdown
        this.populateCountryDropdown(addressDropdown);

        // Set initial dropdown value to match phone input
        addressDropdown.value = iti.getSelectedCountryData().iso2;

        // Sync dropdown when phone input country changes
        const phoneInput = formular.querySelector('.js-iti-phone');
        phoneInput.addEventListener('countrychange', () => {
            addressDropdown.value = iti.getSelectedCountryData().iso2;
        });

        // Sync phone input when dropdown changes
        addressDropdown.addEventListener('change', function() {
            iti.setCountry(this.value);
        });
    },

    /**
     * Populate the country dropdown with available countries
     * @param {HTMLElement} dropdown - The country dropdown element
     */
    populateCountryDropdown: function(dropdown) {
        if (!window.intlTelInputGlobals) return;

        const countryData = window.intlTelInputGlobals.getCountryData();
        
        countryData.forEach(country => {
            if (this.excludedCountries.includes(country.iso2)) return;
            
            const optionNode = document.createElement('option');
            optionNode.value = country.iso2;
            optionNode.textContent = country.name;
            dropdown.appendChild(optionNode);
        });
    }
};